import { render } from "./BackupCodes2FA.vue?vue&type=template&id=4adab00c&scoped=true"
import script from "./BackupCodes2FA.vue?vue&type=script&lang=js"
export * from "./BackupCodes2FA.vue?vue&type=script&lang=js"

import "./BackupCodes2FA.vue?vue&type=style&index=0&id=4adab00c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adab00c"]])

export default __exports__